module.exports = __webpack_public_path__ + "img/TWCNVAG-front.4ef63e65.jpg";